export default {
	start: {
		title: "Plataforma de IA",
		tips: "¡Convierte el desplazamiento en ganancias! Retira dinero diariamente con solo un toque: ¡Tu teléfono, tu máquina de dinero!"
	},
	login: {
		tips: "¿No tienes una cuenta?",
		Signup: "Regístrate",
		logIn: "Iniciar sesión",
		Remember: "Recuérdame",
		form: {
			label: ["Usuario/Teléfono", "Contraseña"]
		},
		forgotPassword: "¿Olvidaste tu contraseña?",
		contactSupport: "Contactar soporte",
		title: "Crear cuenta",
		content: ["¿Necesitas una cuenta?", "Crea una cuenta aquí"]
	},
	register: {
		form: {
			label: [
				"Usuario",
				"Teléfono",
				"Contraseña de transacción",
				"Contraseña de inicio de sesión",
				"Confirmar contraseña de inicio de sesión",
				"Género",
				"Código de invitación",
				"Correo electrónico",
				"Código de verificación"
			],
			rule: {
				Username: "El nombre de usuario debe tener entre 4 y 10 caracteres",
				Email: "Por favor, introduce un correo electrónico válido",
				Phone: "El número de teléfono no puede tener menos de 4 dígitos",
				ConfirmLoginPassword: "Las contraseñas no coinciden",
				TradingPassword: "La contraseña de transacción no puede tener menos de 6 dígitos",
				LoginPassword: "La contraseña de inicio de sesión no puede tener menos de 6 dígitos"
			}
		},
		sendMsg: "¡Código enviado! Por favor, revisa tus mensajes.",
		agree: ["Estoy de acuerdo con {0}", "Aviso de privacidad, MSA", "y", "Términos de servicio"],
		content: [
			"Crea tu cuenta gratuita",
			"¿Ya tienes una cuenta?",
			"Inicia sesión aquí",
			"Crear cuenta",
			"Al continuar, aceptas nuestros"
		]
	}
};
